"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slateReact = require("slate-react");

var _slateHistory = require("slate-history");

var _md = require("react-icons/md");

var _slate = require("slate");

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _MarkButton = _interopRequireDefault(require("./MarkButton"));

var _Element = _interopRequireDefault(require("./Element"));

var _Leaf = _interopRequireDefault(require("./Leaf"));

var _Box = _interopRequireDefault(require("../Box/Box"));

var _BlockButton = _interopRequireDefault(require("./BlockButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable yoda */

/* eslint-disable react/jsx-props-no-spreading */
var RichTextWrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "RichTextEditor__RichTextWrapper",
  componentId: "sc-efwqyv-0"
})(["border:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "1px solid " + theme.colors.dark[3];
});
var ToolbarWrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "RichTextEditor__ToolbarWrapper",
  componentId: "sc-efwqyv-1"
})(["border-bottom:", ";display:grid;width:100%;height:48px;grid-template-columns:repeat(13,40px);align-items:center;justify-items:center;"], function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid " + theme.colors.dark[3];
});

var RichTextEditor = function RichTextEditor(_ref3) {
  var height = _ref3.height,
      initialValue = _ref3.initialValue,
      placeholder = _ref3.placeholder,
      handleChange = _ref3.handleChange;
  var renderElement = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(_Element["default"], props);
  }, []);
  var renderLeaf = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(_Leaf["default"], props);
  }, []);
  var editor = (0, _react.useMemo)(function () {
    return (0, _slateHistory.withHistory)((0, _slateReact.withReact)((0, _slate.createEditor)()));
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_slateReact.Slate, {
    editor: editor,
    initialValue: initialValue,
    onChange: function onChange(value) {
      var isAstChange = editor.operations.some(function (op) {
        return "set_selection" !== op.type;
      });

      if (isAstChange) {
        handleChange(value);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(RichTextWrapper, {
    width: 1 / 1,
    flexDirection: "column",
    height: height || "300px"
  }, /*#__PURE__*/_react["default"].createElement(ToolbarWrapper, null, /*#__PURE__*/_react["default"].createElement(_MarkButton["default"], {
    format: "bold",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatBold, null)
  }), /*#__PURE__*/_react["default"].createElement(_MarkButton["default"], {
    format: "italic",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatItalic, null)
  }), /*#__PURE__*/_react["default"].createElement(_MarkButton["default"], {
    format: "underline",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatUnderlined, null)
  }), /*#__PURE__*/_react["default"].createElement(_MarkButton["default"], {
    format: "code",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdCode, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "heading-one",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdLooksOne, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "heading-two",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdLooksTwo, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "block-quote",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatQuote, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "numbered-list",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatListNumbered, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "bulleted-list",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatListBulleted, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "left",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatAlignLeft, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "center",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatAlignCenter, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "right",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatAlignRight, null)
  }), /*#__PURE__*/_react["default"].createElement(_BlockButton["default"], {
    format: "justify",
    icon: /*#__PURE__*/_react["default"].createElement(_md.MdFormatAlignJustify, null)
  })), /*#__PURE__*/_react["default"].createElement(_slateReact.Editable, {
    style: {
      height: "100%",
      width: "100%",
      outline: "none",
      overflowY: "scroll",
      paddingLeft: "10px",
      paddingRight: "10px"
    },
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: placeholder,
    spellCheck: true,
    autoFocus: true,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        editor.insertBreak();
      }
    }
  })));
};

var _default = RichTextEditor;
exports["default"] = _default;